import { WalletPaymentMethod } from './wallet-payment-method';

export type WalletPaymentMethodType = WalletPaymentMethod['type'];
